import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

export function useFuzzyRate(enabled = true) {
  const [rate, setRate] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const load = () => axios.get(`${API}/fuzzy/price`).then(r => { if (alive) setRate(r.data); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [enabled]);
  return rate;
}

export const fuzzyToXrp = (amount, rate) => (rate && amount > 0 ? amount * rate.xrp_per_fuzzy : null);

export const fmtXrpApprox = (x) => {
  if (x == null) return '';
  const v = x >= 100 ? x.toFixed(0) : x >= 1 ? x.toFixed(2) : x >= 0.01 ? x.toFixed(3) : x.toFixed(5);
  return `≈ ${v} XRP`;
};

export const fmtFuzzyPerXrp = (rate) =>
  rate ? `1 XRP ≈ ${Math.round(rate.fuzzy_per_xrp).toLocaleString()} FUZZY` : null;
